import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const digandoLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#E7392F',
      },
      secondary: {
        main: '#0F4C5C',
      },
      background: {
        default: '#E6EDEE',
        paper: '#FFFFFF',
      },
      navigation: {
        background: '#0F4C5C',
        indicator: '#E7392F',
        color: '#FFFFFF',
        selectedColor: '#FFFFFF',
        navItem: {
          hoverBackground: '#BE2017',
        }
      },
    },
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#E7392F', '#0F4C5C'], shape: shapes.wave }),
  },
  components: {
    BackstageSignInPage: {
      styleOverrides: {
        container: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 700px)',
          marginTop: '200px',
          padding: 0,
          listStyle: 'none',
        },
        item: {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: '400px',
          margin: 0,
          padding: '60px 40px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          // Make column 1 wider
          '&:nth-child(1)': {
            width: '500px',
            minWidth: '500px',
          },
          // Make Type column twice as wide
          '&[data-testid="type-column"], &:nth-child(3)': {
            width: '200px',
            minWidth: '200px',
          },
          // Make column 6 wider
          '&:nth-child(6)': {
            width: '450px',
            minWidth: '450px',
          },
          // Make Tags column wider
          '&:nth-child(7)': {
            width: '300px',
            minWidth: '300px',
          },
        },
      },
    },
  },
});

export const digandoDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: '#E7392F',
      },
      secondary: {
        main: '#0F4C5C',
      },
      background: {
        paper: '#343434',
      },
      navigation: {
        background: '#343434',
        indicator: '#E7392F',
        color: '#FFFFFF',
        selectedColor: '#FFFFFF',
        navItem: {
          hoverBackground: '#BE2017',
        }
      },
    },
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#BE2017', '#0F4C5C'], shape: shapes.wave }),
  },
  components: {
    BackstageSignInPage: {
      styleOverrides: {
        container: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 700px)',
          marginTop: '200px',
          padding: 0,
          listStyle: 'none',
        },
        item: {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: '400px',
          margin: 0,
          padding: '60px 40px',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: '#2A2A2A', // Darker gray instead of black
          }
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          // Make column 1 wider
          '&:nth-child(1)': {
            width: '500px',
            minWidth: '500px',
          },
          // Make Type column twice as wide
          '&[data-testid="type-column"], &:nth-child(3)': {
            width: '200px',
            minWidth: '200px',
          },
          // Make column 6 wider
          '&:nth-child(6)': {
            width: '450px',
            minWidth: '450px',
          },
          // Make Tags column wider
          '&:nth-child(7)': {
            width: '300px',
            minWidth: '300px',
          },
        },
      },
    },
  },
});